var finansudd = finansudd || {};

finansudd.course = new function () {

    var self = this;
    var collapsedHeight = 500;

    this.init = function () {

        if ($('#course-menu').length) {
            self.toggleCourseMenu();
            self.addSliderId();
            self.initCourseMenuItems();
            self.chooseInstance();
        }

        if ($('.course-accordion').length) {
            self.accordionInit();
        }

        self.closeSuccessModal();
        self.showFullDesc();
    };

    this.chooseInstance = function () {
        var hashID = window.location.hash.replace("#", "");

        var initialId = $("#select-id").val();
        if (initialId != null && initialId !== "undefined") {
            $("#SelectedCourseInstanceId").val(initialId);
            self.chooseInstanceInstructorAction(initialId);
        }

        if (hashID != "" && hashID !== "undefined") {
            $("#select-id").val(hashID);
            $("#SelectedCourseInstanceId").val(hashID);
            self.chooseInstanceInstructorAction(hashID)
            self.updateCourseInstancePrice(hashID);
        }

        $("#select-id").change(function () {
            var selectedId = $(this).val();
            $("#SelectedCourseInstanceId").val(selectedId);
            self.chooseInstanceInstructorAction(selectedId);

            self.updateCourseInstancePrice(selectedId);
        });

        $("#SelectedCourseInstanceId").change(function () {
            var selectedId = $(this).val();
            $("#select-id").val(selectedId);
            self.chooseInstanceInstructorAction(selectedId);
        });

    }

    this.updateCourseInstancePrice = function (selectedId) {
        var priceMemberText = $("#courseInstancePriceMember_" + selectedId).val();
        $("#priceMemberDisplay").html(priceMemberText);

        var priceNonMemberText = $("#courseInstancePriceNonMember_" + selectedId).val();
        $("#priceNonMemberDisplay").html(priceNonMemberText);
    }

    this.chooseInstanceInstructorAction = function (selectedId) {
        window.location.hash = selectedId;
        $(".hidden-instructor").hide();
        var classId = "." + selectedId;
        $(classId).show();
    }

    this.closeSuccessModal = function () {

        $("#success-modal").on('hidden.bs.modal', function () {
            var newUrl = window.location.href.split("?")[0];
            window.location = newUrl;

        })
    }


    this.accordionInit = function () {
        self.accordionToggle();
        self.toggleCourseCurriculumProgram();
        self.accordianSetMaxHeight();
        self.accordionItemToggle();

    }

    this.toggleCourseCurriculumProgram = function () {
        var loadValue = $('#module-select option:selected').val();
        var theId = "#" + loadValue;
        $(theId).addClass("selected");

        $('#module-select').on('change', function (event) {
            event.preventDefault();
            $(".curriculum-instance").removeClass("selected");
            var thenewId = "#" + $('#module-select option:selected').val();
            $(thenewId).addClass("selected");
        });
    }

    this.toggleCourseMenu = function () {

        var $document = $(document),
            $element = $('body'),
            className = 'fixed-topmenu';

        $document.scroll(function () {
            $element.toggleClass(className, $document.scrollTop() >= 50);
        });

    };

    this.initCourseMenuItems = function () {
        var $menuItems = $('#course-menu li');

        // Remove the items from menu, if the target does not exits
        $menuItems.each(function () {
            var $this = $(this),
                $target = $($this.find('a').attr('href'));

            if (!$target.length) {
                $this.hide();
            };
        });

    };

    this.addSliderId = function () {
        var $sliderSection = $('.course-slider');

        // Add an item to the first slider
        $sliderSection.first().attr('id', 'course-related');

    };

    this.showFullDesc = function () {
        var $trigger = $('.course-single .item-link.more'),
            inactiveText = $trigger.html(),
            activeText = $trigger.attr('toggle-text') ? $trigger.attr('toggle-text') : inactiveText;

        $trigger.click(function (e) {
            e.preventDefault();
            var $this = $(this);


            $('.hidden-description').slideToggle();

            if (!$this.hasClass('active')) {
                $this
                    .addClass('active')
                    .html(activeText);
            } else {
                $this
                    .removeClass('active')
                    .html(inactiveText);
            }

        });
    };

    this.accordianSetMaxHeight = function () {
        var $module = $('.curriculum-instance');

        $module.each(function () {
            var $this = $(this);
            $content = $this.find('.item-content');

            $content.show();
            $this.attr('data-maxheight', $this.height());
            $content.hide();

            // Init the module collapsed
            $this.css('max-height', collapsedHeight + 'px');
            $this.addClass('collapsed');
        });

    };

    this.accordionToggle = function () {
        var $toggleTrigger = $('#toggle-accordion');


        $toggleTrigger.click(function (e) {
            e.preventDefault();
            var $thisModule = $('.curriculum-instance.selected');
            maxHeight = $thisModule.attr('data-maxheight'); // Store the original height as a variable


            if ($thisModule.hasClass('collapsed')) {

                $thisModule.removeClass('collapsed');
                $thisModule.css('max-height', maxHeight + 'px');

            } else {

                $thisModule.css('max-height', collapsedHeight + 'px');
                $thisModule.addClass('collapsed');

                // Scroll to user to the top of the accordian
                // finansudd.scrollTo.scrollTarget('#course-accordian');
            }
        });

    }

    this.accordionItemToggle = function () {
        var trigger = '.item-toggle';

        $('body').on('click', trigger, function (event) {

            event.preventDefault();
            $module = $(this).parents('.accordion-item');

            $module.toggleClass('active');
        });


    }


}